import React, { useState, useEffect, useRef } from "react";
import "../../Assets/css/ringsettings.css";
import "../../Assets/css/education.css";
import {
  Col,
  Container,
  Row,
  Form,
  Table,
  Image,
  InputGroup,
  FormControl,
} from "react-bootstrap";
import {
  Breadcrumbs,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Drawer,
  InputLabel,
} from "@material-ui/core";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Helmet } from "react-helmet";
import Slider from "rc-slider";
import "../../../node_modules/rc-slider/assets/index.css";
import "../../../node_modules/rc-tooltip/assets/bootstrap.css";
import { NavLink, useHistory } from "react-router-dom";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from "axios";
import CloseIcon from "@material-ui/icons/Close";
import {
  base_url,
  client_name,
  currency,
  currencycode,
  isLogin,
  postHeader,
  setSteps,
  user,
} from "../../Helpers/request";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { toast } from "react-toastify";
import { isMobileOnly, isTablet } from "react-device-detect";
import { Skeleton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { cartlengthvalue } from "../../Reducer/cartReducer";
import { whishlistlength } from "../../Reducer/wishlistReducer";
import { sessionId } from "../../Reducer/homeReducer";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { ProductEnquiry } from "../../Components/Modals";
import Bulovabanner from "../../Assets/images/bulova_banner.jpg";
import FrederiqueConstantBanner from "../../Assets/images/alicias-img/frederique-constant.png";
const { createSliderWithTooltip } = Slider;
const Range = createSliderWithTooltip(Slider.Range);

const Watches = (props) => {
  let { brand, collection } = useParams();

  const [showtext, setShowtext] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const session_Id = useSelector(
    (state) => state.persistedReducer.home.session_id
  );

  const [filterdata, setFilterdata] = useState([]);
  const [filterSortByList, setfilterSortByList] = useState([]);
  const [sortSelected, setsortSelected] = useState("");
  const [productCount, setProductCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [view, setView] = useState(1);
  const [page, setPage] = useState(1);
  const [watchList, setWatchList] = useState([]);
  const [demofilterlist, setDemofilterlist] = useState([]);
  const [left, setLeft] = useState(false);
  const [addedfilter, setAddedfilter] = useState(
    JSON.parse(sessionStorage.getItem("bw-watchfilter"))
      ? JSON.parse(sessionStorage.getItem("bw-watchfilter"))
      : []
  );
  const [checkFilter, setcheckFilter] = useState([]);
  const [screenWidth, setScreenWidth] = useState(window.screen.width);
  const [filtercount, setFiltercount] = useState(0);
  const [filter, setFilter] = useState([]);
  const [filtersuccess, setFiltersuccess] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [loader, setLoader] = useState(true);
  const [expanded, setExpanded] = useState([]);
  const [inquiry, setInquiry] = useState(false);
  const [inquiry_id, setInquiry_id] = useState("");
  const [displayBrandBanner, setDisplayBrandBanner] = useState(false);
  const [skuSearch, setSkuSearch] = useState(null);
  const skuRef = useRef();

  useEffect(() => {
    if ((skuSearch && skuSearch?.length > 3) || skuSearch === "") {
      watchlistdata(skuSearch);
    }
  }, [skuSearch]);

  const resizeScreen = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    resizeScreen();
    window.addEventListener("resize", resizeScreen);
    return () => {
      window.removeEventListener("resize", resizeScreen);
    };
  });

  useEffect(() => {
    watchlistdata();
  }, [page]);
  useEffect(() => {
    if (brand === "bulova") {
      setDisplayBrandBanner(!displayBrandBanner);
    }
    return () => {
      setDisplayBrandBanner(false);
    };
  }, [brand]);

  useEffect(() => {
    watchlistdata();
    setPage(1);
    var count = 0;
    addedfilter?.map((val) => {
      if (val?.name.length) {
        count++;
      }
    });
    count > 0 ? setFiltercount(1) : setFiltercount(0);
  }, [addedfilter, sortSelected]);

  useEffect(() => {
    filterApi();
  }, [brand]);

  const watchlistdata = (skuSearch) => {
    setLoader(true);
    setWatchList([]);
    let data = {
      currency_code: currencycode,
      start: (page - 1) * 18,
      length: 18,
      sort_by: sortSelected,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
      token: isLogin ? user.token : "",
      filterdata: addedfilter,
      search_watch_text: skuSearch ? skuSearch : "",
    };

    if (collection) {
      data = { ...data, collection };
    }
    axios
      .post(
        collection
          ? base_url + "/watch/watch_list_collections"
          : base_url + "/watch/watch_list",
        data,
        {
          headers: postHeader,
        }
      )
      .then((res) => {
        if (res.data.status === 1) {
          setTotalCount(res.data.data?.count);
          setWatchList(res.data.data?.result);
          var count = (res.data.data?.count / 18).toFixed();
          if (count * 18 >= res.data.data?.count) {
            setPageCount(count);
          } else {
            setPageCount(Number(count) + 1);
          }
          setLoader(false);
        } else {
          setPageCount(0);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlePageChange = (e, value) => {
    setPage(value);
    window.scrollTo(0, 0);
  };

  const addtowishlist = (product_id, wishindex) => {
    const data = {
      currency_code: currencycode,
      user_id: user.user_id ? user.user_id : "",
      session_id: session_Id,
      product_id: product_id?.stock_no,
      type: "watch",
      token: isLogin ? user.token : "",
    };
    axios
      .post(base_url + "/order/add_to_wishlist", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          const productlist = watchList?.map((obj, index) =>
            index == wishindex
              ? Object.assign(obj, { is_wishlist: res.data.data?.wishlist_id })
              : obj
          );
          setWatchList(productlist);
          dispatch(whishlistlength(res.data.data?.count));
        } else if (res.data.status == 2) {
          localStorage.removeItem("bw-user");
          dispatch(whishlistlength(0));
          dispatch(cartlengthvalue(0));
          dispatch(sessionId(""));
          history.push("/");
          window.location.reload(true);
        } else {
          toast.error(res.message, { autoClose: 3000 });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const filterApi = () => {
    const data = {
      currency_code: currencycode,
    };
    axios
      .post(base_url + "/watch/watch_filter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status === 1) {
          setFilterdata(res?.data?.data);
          setfilterSortByList(res?.data?.sort_by);
          var temp = [];
          res?.data?.data?.forEach((e) => {
            e.value.map((val) => {
              val?.title !== "Brand"
                ? temp.push({
                    title: val?.title,
                    filter: [],
                    name: [],
                  })
                : val?.title === "Brand" && brand
                ? temp.push({
                    title: "Brand",
                    filter: [
                      brand?.replaceAll("-", " ")?.charAt(0)?.toUpperCase() +
                        brand?.replaceAll("-", " ").slice(1),
                    ],
                    name: [
                      brand?.replaceAll("-", " ")?.charAt(0)?.toUpperCase() +
                        brand?.replaceAll("-", " ").slice(1),
                    ],
                  })
                : temp.push({
                    title: val?.title,
                    filter: [],
                    name: [],
                  });
            });
          });
          setDemofilterlist(temp);
          sessionStorage.setItem("bw-watchfilter", JSON.stringify(temp));
          setAddedfilter(
            addedfilter.length > 0
              ? JSON.parse(sessionStorage.getItem("bw-watchfilter"))
              : temp
          );
          addedfilter.forEach((e, i) => {
            if (e.filter.length > 0) {
              setFiltercount(1);
            } else {
              //setFiltercount(0);
              //sessionStorage.setItem("bw-watchfilter",JSON.stringify(temp))
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handlecheckChange = (e, title, value, name) => {
    console.log("e, title=======", e, title, value, name);
    var changedata = [...addedfilter];
    addedfilter?.map((val) => {
      var filterdata = [...val.filter];
      var fname = [...val.name];
      if (val.title == title) {
        if (val.filter?.includes(value)) {
          filterdata = val.filter?.filter((data) => data !== value);
          fname = val.name?.filter((data) => data !== name);
        } else {
          console.log("e, title=======", e, title, value, name);
          filterdata.push(value);
          fname.push(name);
        }
        changedata = changedata.map((obj) =>
          obj.title == title
            ? Object.assign(obj, { filter: filterdata, name: fname })
            : obj
        );
        setAddedfilter(changedata);
        sessionStorage.setItem("bw-watchfilter", JSON.stringify(changedata));
      }
    });
    if (changedata.length > 0) {
      setFiltercount(1);
    }
  };

  const checkboxcheck = (title, value, i) => {
    var data = false;
    if (addedfilter !== null) {
      addedfilter.some((a) => {
        if (a?.title === title) {
          let founded = a?.filter.find(
            (f) => f?.toLowerCase() === value?.toLowerCase()
          );
          if (founded) {
            data = true;
            return;
          }
        }
      });
      // if (addedfilter.some((ele) => ele.filter.includes(`${value}`))) {
      //   data = true;
      // }
    }
    return data;
  };

  const handleChange = (panel) => (event, newExpanded) => {
    // setShowFilter(true);
    // console.log('panelpanel==', panel);

    if (expanded?.includes(panel)) {
      var data = expanded?.filter(function (person) {
        return person !== panel;
      });
      setExpanded(data);
    } else {
      // setExpanded([...expanded, newExpanded ? false : panel]);
      setExpanded([...expanded, panel]);
    }
  };

  const clearFilter = () => {
    skuRef.current.value = "";
    setSkuSearch(null);
    setAddedfilter(demofilterlist);
    sessionStorage.setItem("bw-watchfilter", JSON.stringify(demofilterlist));
    filterApi();
  };

  const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);

  const handleShowInquiry = (id) => {
    setInquiry_id(id);
    setInquiry(true);
  };
  const handleCloseInquiry = () => {
    setInquiry_id("");
    setInquiry(false);
  };

  const bulovabrand = watchList.every((item) => item.brand === "BULOVA");
  const frebrand = watchList.every(
    (item) => item.brand === "FREDERIQUE CONSTANT"
  );

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <div className="rcs_ringsetting_section mt-3">
        {displayBrandBanner ? (
          <>
            <Image
              style={{ width: "100%" }}
              src={Bulovabanner}
              alt="banner_image"
              onClick={() => history.push("/")}
            />
          </>
        ) : null}
        <Container className="rcs_shap-wizard_container">
          <Row>
            <Col className="rcs_breadcrumb mb-2">
              <Breadcrumbs aria-label="breadcrumb">
                <NavLink underline="hover" color="inherit" to="/">
                  Home
                </NavLink>
                <Typography color="text.primary">Watches</Typography>
              </Breadcrumbs>
            </Col>
          </Row>

          <Row className="w-100 d-block m-auto">
            <Col xs={12} className="p-0">
              <div className="rcs_diamond_content1 mb-3">
                <h1 className="text-left text-capitalize fs30">
                  {displayBrandBanner
                    ? " Bulova"
                    : brand == "oris"
                    ? "Oris"
                    : brand == "michele"
                    ? "Michele"
                    : brand == "longines"
                    ? "Longines"
                    : brand == "Frederique-Constant"
                    ? "Frederique Constant"
                    : brand == "Bell-&-Ross"
                    ? "Bell & Ross"
                    : "Find Watches Easily"}{" "}
                  {collection ? <>- {collection}</> : null}
                </h1>

                {displayBrandBanner ? (
                  <p>
                    Unleash your style with Bulova, where innovation meets
                    refined elegance. Since 1875, Bulova has been at the
                    forefront of watchmaking, skillfully merging advanced
                    technology with timeless design. Each timepiece is a
                    stunning blend of sophistication and artistry, crafted for
                    those who value both heritage and modernity. Whether you’re
                    making a statement at a special event or elevating your
                    everyday look, a Bulova watch is the perfect accessory that
                    reflects your unique flair. Step into a realm of exceptional
                    craftsmanship and redefine your wristwear with Bulova –
                    where every second is an invitation to express your
                    individuality with confidence and grace.
                  </p>
                ) : brand == "oris" ? (
                  <p>
                    Discover Oris, where Swiss precision and timeless elegance
                    come together in every detail. Each timepiece is a blend of
                    traditional craftsmanship and modern innovation, designed
                    for those who value both heritage and forward-thinking
                    style. From our Heritage Collection that honors our rich
                    legacy to our eco-conscious models driving sustainable
                    luxury, every watch is a reflection of purpose and
                    individuality. Explore our exclusive limited editions,
                    crafted to be as unique as you are. Join the Oris community,
                    where every tick tells a story of adventure, artistry, and
                    enduring sophistication.
                  </p>
                ) : brand == "michele" ? (
                  <p>
                    Experience the enchanting allure of Michele Watch, where
                    modern sophistication effortlessly meets timeless elegance.
                    Each timepiece is a stunning blend of exquisite
                    craftsmanship and distinctive design, making it a true
                    statement of individuality. Imagine wearing a watch that not
                    only complements your style but also captivates attention
                    and sparks curiosity. With a Michele watch on your wrist,
                    you elevate everyday moments into extraordinary ones,
                    radiating confidence and grace. Every tick resonates with
                    your unique journey, reminding you that elegance is not just
                    about timekeeping; it’s about celebrating life’s remarkable
                    experiences. Embrace the art of sophistication with Michele
                    Watch.
                  </p>
                ) : brand == "longines" ? (
                  <p>
                    Dive into the storied legacy of Longines, a hallmark of
                    Swiss watchmaking that has defined elegance and precision
                    for over 190 years. Founded in 1832, Longines expertly
                    blends exquisite craftsmanship with cutting-edge technology,
                    creating timepieces that elevate your style and resonate
                    with sophistication. Wearing a Longines watch isn’t just
                    about keeping time; it’s about embracing a rich heritage
                    adorned by explorers, athletes, and icons alike. Each piece
                    transcends fleeting trends, making it the ultimate accessory
                    for any occasion. Elevate your wristwear with Longines, and
                    let every tick reflect your unique taste and a timeless
                    connection to the world of luxury.
                  </p>
                ) : brand == "Frederique-Constant" ? (
                  <p>
                    Step into sophistication with Frederique Constant, where
                    contemporary style meets classic elegance. Each timepiece is
                    a blend of meticulous craftsmanship and innovative design,
                    making it the perfect accessory for those who appreciate
                    quality and refinement. A Frederique Constant watch is more
                    than just a timepiece; it’s a symbol of your unique taste
                    and individuality. Whether you’re dressing up for a formal
                    event or adding a touch of luxury to your everyday look,
                    this watch enhances your style effortlessly. Elevate your
                    wristwear with Frederique Constant and make every moment an
                    expression of timeless elegance and confidence.
                  </p>
                ) : brand == "Bell-&-Ross" ? (
                  <p>
                    Step up your style with Bell & Ross – where precision and
                    elegance meet in perfect harmony. Inspired by aviation, each
                    timepiece merges advanced technology with sleek, modern
                    design, crafted for those who live boldly. This is more than
                    a watch – it's a symbol of confidence and adventure, made to
                    push boundaries and redefine your daily routine. From the
                    precision of the cockpit to the demands of your lifestyle,
                    Bell & Ross elevates how you experience time. Embrace every
                    moment with a watch that’s as daring and dynamic as you are.
                    Bell & Ross – where time transforms your life.
                  </p>
                ) : (
                  <p>
                    Discover a curated collection of luxury watches that
                    epitomize precision, innovation, and timeless elegance. From
                    Oris’ sustainable sophistication and Bell & Ross’ bold
                    aviation-inspired design to the captivating charm of Michele
                    Watches, each brand tells a unique story. Longines blends
                    nearly two centuries of Swiss heritage with refined
                    craftsmanship, while Bulova and Frederique Constant offer a
                    modern take on classic artistry. Each timepiece in our
                    selection is crafted to elevate your style and express your
                    individuality, creating a seamless blend of tradition and
                    forward-thinking design.
                  </p>
                )}
              </div>
            </Col>
          </Row>
          <Row className="w-100 m-auto">
            {screenWidth > 767 && !brand ? (
              <Col sm={3} className="pb-5 remPadLg">
                <button aria-label="clear all filters"
                  onClick={clearFilter}
                  className="clear-all-filters noBtn"
                  disabled={!filtercount && !skuSearch}
                >
                  CLEAR ALL
                </button>
                <div className="sidebarWrapper">
                  <div className="mt-3 mb-3">
                    <InputGroup className="sku_filter">
                      <InputLabel className="d-none" htmlFor="stockno">
                        Search By Stock No. / SKU
                      </InputLabel>
                      <FormControl
                        id="stockno"
                        aria-label="Search By Stock No. / SKU"
                        type="text"
                        placeholder="Search By Stock No. / SKU"
                        value={skuSearch}
                        onChange={(e) => {
                          let skuval = e.target.value;
                          setSkuSearch(skuval);
                        }}
                        ref={skuRef}
                      />
                    </InputGroup>
                  </div>

                  <div className="rcs_filter_tags">
                    {!filtercount ? (
                      ""
                    ) : (
                      <div className="rcs_filter_list">
                        <div className="filter_tgs_list">
                          {addedfilter?.map((val) =>
                            val.name?.map((items, index) => (
                              <>
                                <Button className="gs_filter_btn" aria-label="close">
                                  {items}
                                  <CloseIcon
                                    onClick={(e) =>
                                      handlecheckChange(
                                        e,
                                        val.title,
                                        val.filter[index],
                                        items
                                      )
                                    }
                                    className="gs_tags_svg"
                                  />
                                </Button>
                              </>
                            ))
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  {filterdata?.map((val, index) => (
                    <Accordion
                      // expanded={expanded?.includes("panel" + index) ? false: true}
                      expanded={expanded?.includes("panel" + index)}
                      onChange={handleChange("panel" + index)}
                      className="rcs_accordion_item noShadow watchFilters rcs_accordion"
                    >
                      <AccordionSummary
                        expandIcon={
                          expanded?.includes("panel" + index) ? (
                            <span className="fww">-</span>
                          ) : (
                            <span className="fww">+</span>
                          )
                        }
                        aria-controls="panel2a-content"
                        id={`panel2a-header`}
                        className="w-100"
                      >
                        <Typography>
                          <div className="fs16 fw600">{val?.title}</div>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails className="pb-0 pt-0">
                        <div className="rcs_price_filter">
                          {val?.value?.map((item, index1) => (
                            <>
                              {val?.title !== item?.title && (
                                <h6>
                                  <span>{item?.title}</span>
                                </h6>
                              )}
                              <>
                                {item?.value?.map((newVal, index2) => (
                                  <FormGroup>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={checkboxcheck(
                                            item?.title,
                                            newVal?.value,
                                            index
                                          )}
                                          onChange={(e) =>
                                            handlecheckChange(
                                              e,
                                              item?.title,
                                              newVal?.name,
                                              newVal?.value
                                            )
                                          }
                                        />
                                      }
                                      label={newVal.name}
                                    />
                                  </FormGroup>
                                ))}
                              </>
                            </>
                          ))}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </div>
              </Col>
            ) : (
              ""
            )}

            {!brand ? (
              <div className="rcs_mobile_filter_section">
                <Drawer
                  anchor="left"
                  open={left}
                  onClose={() => setLeft(false)}
                >
                  <div
                    className="drawerX"
                    role="presentation"
                    onKeyDown={() => setLeft(false)}
                  >
                    <div className="rcs_filter_tags ">
                      {!filtercount ? (
                        ""
                      ) : (
                        <div className="rcs_filter_list">
                          <h5>
                            <span>Filtering by:</span>
                            <button aria-label="clear all"
                              onClick={() => {
                                setAddedfilter(demofilterlist);
                                sessionStorage.setItem(
                                  "bw-watchfilter",
                                  JSON.stringify(demofilterlist)
                                );
                                filterApi();
                              }}
                              className="clear-all-filters noBtn"
                            >
                              CLEAR ALL
                            </button>
                          </h5>
                          <div className="filter_tgs_list">
                            {addedfilter?.map((val) =>
                              val.name?.map((items, index) => (
                                <>
                                  <Button className="gs_filter_btn" aria-label="close">
                                    {items}
                                    <CloseIcon
                                      onClick={(e) =>
                                        handlecheckChange(
                                          e,
                                          val.title,
                                          val.filter[index],
                                          items
                                        )
                                      }
                                      className="gs_tags_svg"
                                    />
                                  </Button>
                                </>
                              ))
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    {filterdata?.map((val, index) => (
                      <Accordion
                        expanded={
                          expanded?.includes("panel" + index) ? false : true
                        }
                        onChange={handleChange("panel" + index)}
                        className="rcs_accordion_item noShadow watchFilters rcs_accordion"
                      >
                        <AccordionSummary
                          expandIcon={
                            !expanded?.includes("panel" + index) ? (
                              <span className="fww">-</span>
                            ) : (
                              <span className="fww">+</span>
                            )
                          }
                          aria-controls="panel2a-content"
                          id={`panel2a-header`}
                          className="w-100"
                        >
                          <Typography>
                            <div className="fs16 fw600 pl-3">{val?.title}</div>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails className="pb-0 pt-0">
                          <div className="rcs_price_filter">
                            {val?.value?.map((item, index1) => (
                              <>
                                <h6>
                                  <span>{item?.title}</span>
                                </h6>
                                <>
                                  {item?.value?.map((newVal, index2) => (
                                    <FormGroup>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            checked={checkboxcheck(
                                              item?.title,
                                              newVal?.value,
                                              index
                                            )}
                                            onChange={(e) =>
                                              handlecheckChange(
                                                e,
                                                item?.title,
                                                newVal?.name,
                                                newVal?.value
                                              )
                                            }
                                          />
                                        }
                                        label={newVal.name}
                                      />
                                    </FormGroup>
                                  ))}
                                </>
                              </>
                            ))}
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </div>
                </Drawer>
              </div>
            ) : (
              ""
            )}

            <Col
              xs={12}
              sm={!brand ? 9 : 12}
              className="rcs_diamond_table pl-2 pr-2 mb-md-3 mb-0"
            >
              <div className="rcs_view mobPb15 mb-5">
                <Row className="w-100   align-items-center">
                  <Col xs={4} md={6} className={view == 1 ? "" : "mb-5"}>
                    {screenWidth < 767 && (
                      <div>
                        {!brand ? (
                          <button aria-label="filter"
                            className="noBtn"
                            onClick={() => setLeft(true)}
                          >
                            Filter
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                    {screenWidth > 767 && (
                      <div className="pt-2 pb-2 text-left">
                        {loader ? (
                          <>
                            <Skeleton
                              variant="text"
                              animation="wave"
                              className=""
                              width={150}
                              height={20}
                            />
                          </>
                        ) : (
                          <span className="pr-0">
                            Showing {totalCount} Result(s)
                          </span>
                        )}
                      </div>
                    )}
                  </Col>

                  <Col xs={8} lg={6} md={6}>
                    <div className="d-flex align-items-center justify-content-end">
                      <label
                        className="mb-0 mr-1 fs14"
                        htmlFor="sorting"
                        style={{ minWidth: "55px" }}
                      >
                        Sort By:{" "}
                      </label>
                      <select
                        style={{ minWidth: "130px" }}
                        name=""
                        id="sorting"
                        className="form-control w-auto"
                        onChange={(e) => setsortSelected(e.target.value)}
                      >
                        {filterSortByList.length > 0 &&
                          filterSortByList?.map((e, i) => (
                            <option key={i} value={e.value}>
                              {e.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </Col>
                </Row>
              </div>

              {screenWidth < 767 && (
                <div className="pt-2 pb-2 text-center">
                  {loader ? (
                    <>
                      <Skeleton
                        variant="text"
                        animation="wave"
                        className=""
                        width={150}
                        height={20}
                      />
                    </>
                  ) : (
                    <span className="pr-0"> Showing {totalCount} Results </span>
                  )}
                </div>
              )}

              {view === 2 ? (
                ""
              ) : (
                <>
                  <Row>
                    {loader ? (
                      <>
                        {[...Array(15)].map((val) => (
                          <>
                            <Col lg={4} md={4} xs={12}>
                              <Skeleton
                                variant="text"
                                style={{
                                  transform: "unset",
                                  margin: "0 auto",
                                  marginBottom: "15px",
                                }}
                                animation="wave"
                                height={300}
                              />
                            </Col>
                          </>
                        ))}
                      </>
                    ) : (
                      watchList.map((row, index) => (
                        <Col lg={4} md={4} xs={6} className="parentListWatch">
                          <div className="rcs_diamonds_grid_content watchList">
                            {/* <span className="rcs_diamonds_grid_info" >
                                        <img src="/static/media/inquir.9a98e4da.svg" /></span> */}
                            <span
                              className="rcs_diamonds_grid_wishlist"
                              style={{ cursor: "pointer" }}
                            >
                              {row.is_wishlist == "0" ? (
                                <FavoriteBorderIcon
                                  onClick={() => addtowishlist(row, index)}
                                />
                              ) : (
                                <FavoriteIcon
                                  onClick={() => addtowishlist(row, index)}
                                  className="animate__animated animate__heartBeat"
                                />
                              )}
                            </span>
                            <div className="d-flex flex-column justify-content-between h-100">
                              <NavLink
                                className="imgWrapperWatch"
                                to={
                                  "/watch-details/" +
                                  encodeURIComponent(row.stock_no)
                                }
                              >
                                <img
                                  src={row.imagelink}
                                  alt="diamonds"
                                  className
                                />
                              </NavLink>

                              <div className="rcs_product_info">
                                <NavLink
                                  to={
                                    "/watch-details/" +
                                    encodeURIComponent(row.stock_no)
                                  }
                                >
                                  <h3>{row.name}</h3>
                                </NavLink>
                                <p className="rcs_emailprice rcs_diamonds_price_s">
                                  {row.enable_ecommerce == "1" ? (
                                    <>
                                      {currency}
                                        {row?.cutoff_price}
                                      <del className="pl-1" style={{fontSize:"12px"}}>
                                       {currency}{row.sale_price}
                                      </del>
                                       <span style={{color:"red", fontSize:"10px"}}>
                                        {row?.cutoff}

                                       </span>
                                    </>
                                  ) : (
                                    <span
                                      style={{
                                        borderBottom: "1px solid rgb(0, 0, 0)",
                                        padding: "7px 0px",
                                        textTransform: "uppercase",
                                        fontSize: "11px",
                                        textAlign: "center",
                                      }}
                                      variant="contained"
                                      // className="rcs_acc_button rcs_acc_button1 w-100 mb-3"
                                      onClick={() =>
                                        handleShowInquiry(row?.stock_no)
                                      }
                                    >
                                      Inquiry
                                    </span>
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))
                    )}
                  </Row>
                  <Row className="mt-5 mb-3">
                    <Col xs={12} className="pr-0 m-auto">
                      <div
                        className="rcs_sorting_pagi"
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        <Stack
                          spacing={2}
                          className="mt-3 mb-3 rcs_diamond_pagination diamond_p"
                        >
                          <Pagination
                            count={pageCount}
                            page={page}
                            onChange={handlePageChange}
                            shape="rounded"
                          />
                        </Stack>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
            </Col>
          </Row>
          {/*Inquiry Modal*/}
          {inquiry && inquiry_id ? (
            <ProductEnquiry
              productid={inquiry_id}
              handleCloseInquiry={handleCloseInquiry}
            />
          ) : (
            ""
          )}
          {/*Inquiry Modal*/}
        </Container>

        <Container className="rcs_shap-wizard_container mb-5">
          {bulovabrand ? (
            <div className="watchsContent">
              <div
                style={
                  showtext
                    ? { height: "100%" }
                    : { height: "200px", overflow: "hidden" }
                }
                className="watchsContentData"
              >
                <>
                  <h2>Bulova Watches</h2>
                  <p>
                    <span>
                      Discover the elegance and precision of Bulova watches at
                      Alicia&apos;s Jewelers. Renowned for their innovation and
                      craftsmanship, Bulova timepieces combine advanced
                      technology with timeless style. Each watch is meticulously
                      designed to offer both functionality and sophistication,
                      making them the perfect accessory for any occasion.
                      Explore our exclusive collection at Alicia&apos;s Jewelers
                      and find the Bulova watch that perfectly complements your
                      style.
                      <br />
                      &nbsp;
                      <br /> <strong>History of Bulova Watches</strong>
                    </span>
                  </p>
                  <p>
                    <span>
                      Founded in 1875 by Joseph Bulova in New York City, Bulova
                      began as a small jewelry store specializing in fine
                      timepieces. In 1912, Bulova made a significant
                      breakthrough by introducing the first fully made American
                      wristwatch, revolutionizing the industry and setting a new
                      standard for precision and style.
                    </span>
                  </p>
                  <p>
                    <span>
                      During World War I, Bulova&apos;s innovative timekeeping
                      technology gained prominence, becoming the official
                      supplier of military watches for the U.S. Armed Forces.
                      This reputation for reliability was further solidified in
                      1923 when Bulova introduced its first advertisement,
                      marking a pioneering moment in watch advertising.
                    </span>
                  </p>
                  <p>
                    <span>
                      In 1960, Bulova made history again with the introduction
                      of the Accutron, the world&apos;s first fully electronic
                      watch, featuring a tuning fork mechanism that offered
                      unprecedented accuracy. This innovation set the stage for
                      future advancements in horology.
                    </span>
                  </p>
                  <p>
                    <span>
                      Today, Bulova remains at the forefront of watchmaking,
                      combining heritage with cutting-edge technology. The brand
                      continues to produce high-quality timepieces that reflect
                      both its rich history and commitment to innovation.
                    </span>
                  </p>
                  <p>
                    <span>
                      At Alicia&apos;s Jewelers, we are proud to offer a curated
                      selection of Bulova watches, embodying both tradition and
                      modern excellence.
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>Why Choose a Bulova Watch?</span>
                    </strong>
                  </p>
                  <ol start="1" type="1">
                    <li>
                      <strong>
                        <span>Exceptional Craftsmanship:</span>
                      </strong>
                      <span>
                        &nbsp;Bulova watches are renowned for their meticulous
                        craftsmanship and attention to detail. Each timepiece is
                        engineered with precision and designed to meet the
                        highest standards of quality.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>Innovative Technology:</span>
                      </strong>
                      <span>
                        &nbsp;Bulova has a rich history of innovation, from the
                        introduction of the Accutron, the world&apos;s first
                        electronic watch, to their latest advancements in quartz
                        and automatic movements. Choosing Bulova means embracing
                        cutting-edge technology and accuracy.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>Timeless Design:</span>
                      </strong>
                      <span>
                        &nbsp;Bulova combines classic elegance with modern
                        style, offering a diverse range of designs to suit any
                        taste. Whether you prefer a sophisticated dress watch or
                        a sporty chronograph, Bulova&apos;s collection provides
                        options that complement any wardrobe.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>Reliability:</span>
                      </strong>
                      <span>
                        &nbsp;With over a century of watchmaking experience,
                        Bulova is synonymous with reliability and durability.
                        Their timepieces are crafted to withstand the test of
                        time, ensuring that your watch remains a cherished
                        accessory for years to come.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>Prestigious Heritage:</span>
                      </strong>
                      <span>
                        &nbsp;Established in 1875, Bulova has a storied legacy
                        of excellence in watchmaking. By choosing Bulova, you
                        become a part of this prestigious tradition, owning a
                        piece of horological history.
                      </span>
                    </li>
                  </ol>
                  <p>
                    <span>
                      At Alicia&apos;s Jewelers, we proudly offer a curated
                      selection of Bulova watches, allowing you to experience
                      firsthand the blend of tradition, innovation, and style
                      that defines this esteemed brand.
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>Bulova Collections</span>
                    </strong>
                  </p>
                  <ol start="1" type="1">
                    <li>
                      <strong>
                        <span>
                          Bulova Accutron Collection
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        The Accutron collection pays homage to Bulova&apos;s
                        pioneering electronic timekeeping technology. Featuring
                        the renowned tuning fork movement, these watches offer
                        exceptional accuracy and a sleek, modern design. The
                        collection includes both classic and contemporary
                        styles, perfect for those who appreciate innovative
                        horology.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Bulova Precisionist Collection
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Known for its unrivaled precision, the Precisionist
                        collection boasts a quartz movement that delivers
                        exceptional accuracy with a continuous sweeping second
                        hand. These watches are designed for those who demand
                        both style and superior timekeeping performance, with
                        designs ranging from elegant to sporty.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Bulova Classic Collection
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        The Classic collection embodies timeless elegance with a
                        range of traditional designs and sophisticated details.
                        These watches feature refined aesthetics, including
                        polished cases, elegant dials, and premium materials,
                        making them ideal for formal occasions and everyday
                        wear.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Bulova Curv Collection
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        The Curv collection stands out with its uniquely curved
                        case design, engineered to conform to the natural shape
                        of the wrist. This innovative design houses advanced
                        chronograph movements and modern features, offering both
                        comfort and functionality with a contemporary flair.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Bulova Marine Star Collection
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Designed for water enthusiasts, the Marine Star
                        collection combines rugged durability with stylish
                        designs. These watches are equipped with water
                        resistance, luminous dials, and robust materials, making
                        them perfect for diving and other aquatic activities.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Bulova Diamond Collection
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        The Diamond collection features timepieces adorned with
                        dazzling diamonds, adding a touch of luxury and
                        sophistication. These watches blend high-performance
                        movements with sparkling embellishments, making them an
                        exquisite choice for those who enjoy a bit of glamour.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Bulova Sport Collection
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        The Sport collection offers a blend of functionality and
                        modern aesthetics, tailored for active lifestyles. With
                        features like chronographs, tachymeters, and durable
                        materials, these watches are designed to keep up with
                        dynamic pursuits while maintaining a sleek look.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Bulova Lunar Pilot Collection
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Inspired by Bulova&apos;s history with space
                        exploration, the Lunar Pilot collection reflects the
                        brand&apos;s legacy of precision and innovation.
                        Featuring a design reminiscent of the watch worn by
                        astronauts during the Apollo missions, these timepieces
                        are perfect for those with a passion for space and
                        history.
                      </span>
                    </li>
                  </ol>
                  <p>
                    <span>
                      At Alicia&apos;s Jewelers, we offer a curated selection of
                      Bulova&apos;s diverse collections, ensuring that you can
                      find the perfect timepiece to suit your style and needs.
                      <br />
                      &nbsp;
                      <br /> <strong>Bulova Watch Types</strong>
                    </span>
                  </p>
                  <ol start="1" type="1">
                    <li>
                      <strong>
                        <span>
                          Chronograph
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Chronograph watches combine traditional timekeeping with
                        stopwatch functionality. Bulova&apos;s chronograph
                        models feature multiple sub-dials that allow for precise
                        measurement of elapsed time, making them ideal for
                        sports enthusiasts and professionals who need accurate
                        timing. These watches often include additional features
                        like tachymetric scales for measuring speed.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Automatic
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Automatic watches, also known as self-winding watches,
                        use the natural motion of the wearer&rsquo;s wrist to
                        power the movement. Bulova&rsquo;s automatic timepieces
                        feature intricate mechanical movements that offer both
                        reliability and a connection to traditional watchmaking
                        craftsmanship. These watches are appreciated for their
                        smooth operation and the artistry involved in their
                        design.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Quartz
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Quartz watches are known for their accuracy and low
                        maintenance. Bulova&rsquo;s quartz timepieces utilize
                        battery-powered movements that ensure precise
                        timekeeping with minimal deviation. These watches are
                        ideal for those who value punctuality and convenience,
                        combining modern technology with stylish design.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Digital
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Digital watches display time through an electronic
                        interface, often featuring LCD or LED screens.
                        Bulova&apos;s digital models offer functionality with
                        easy-to-read displays and additional features such as
                        alarms, backlighting, and timers. These watches are
                        perfect for those who prefer a contemporary and
                        tech-savvy approach to timekeeping.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Diving
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Diving watches are designed to withstand underwater
                        conditions and provide accurate timekeeping during
                        aquatic activities. Bulova&rsquo;s diving timepieces are
                        equipped with robust features like high water
                        resistance, unidirectional bezels, and luminous dials
                        for readability in low-light conditions. They are ideal
                        for professional divers and those who enjoy water
                        sports.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Dress
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Dress watches are characterized by their elegant and
                        refined designs, making them suitable for formal
                        occasions. Bulova&rsquo;s dress watches often feature
                        slim profiles, classic dials, and luxurious materials
                        such as leather straps or precious metals. These
                        timepieces are perfect for complementing sophisticated
                        attire and special events.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Field
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Field watches are designed for durability and
                        functionality, often featuring rugged cases and
                        easy-to-read dials. Bulova&rsquo;s field watches are
                        crafted to withstand harsh conditions and provide
                        reliable performance in outdoor activities. They
                        typically include features like luminous markers and
                        sturdy straps, making them ideal for adventurers and
                        outdoor enthusiasts.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Pilot
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Pilot watches are inspired by aviation and are designed
                        to provide essential timekeeping functions for pilots
                        and aviation enthusiasts. Bulova&rsquo;s pilot watches
                        often feature large, legible dials, multiple time zones,
                        and additional complications like chronographs or
                        altimeters. These watches combine functionality with a
                        nod to aviation history.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Luxury
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Luxury watches from Bulova are distinguished by their
                        high-end materials, intricate designs, and exceptional
                        craftsmanship. These timepieces often feature premium
                        materials such as diamonds, gold, and fine leather,
                        offering a blend of opulence and precision. Luxury
                        watches are perfect for those seeking a statement piece
                        that exemplifies refinement and elegance.
                      </span>
                    </li>
                  </ol>
                  <p>
                    <span>
                      At Alicia&apos;s Jewelers, we offer a diverse selection of
                      Bulova watches across these categories, ensuring that you
                      can find the perfect type to match your lifestyle and
                      preferences.
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>Bulova Watch Materials</span>
                    </strong>
                  </p>
                  <ol start="1" type="1">
                    <li>
                      <strong>
                        <span>
                          Stainless Steel
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Stainless steel is a popular material for watch cases
                        and bracelets due to its durability, resistance to
                        corrosion, and polished appearance. Bulova&rsquo;s
                        stainless steel watches offer a sleek, modern look and
                        are known for their strength and longevity, making them
                        suitable for both everyday wear and formal occasions.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Gold
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Gold adds a touch of luxury and sophistication to Bulova
                        timepieces. Available in yellow gold, rose gold, and
                        white gold, this material is often used for bezels,
                        cases, and bracelets. Gold watches exude opulence and
                        are perfect for those seeking a classic and elegant
                        aesthetic.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Ceramic
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Ceramic is known for its lightweight and
                        scratch-resistant properties. Bulova&rsquo;s ceramic
                        watches feature smooth, durable cases and bracelets that
                        maintain their appearance over time. The
                        material&rsquo;s high-tech finish also offers a modern
                        and stylish look.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Leather
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Leather straps provide a classic and comfortable option
                        for watch bands. Bulova&rsquo;s leather straps come in
                        various finishes and colors, including smooth, textured,
                        and embossed designs. Leather adds a touch of
                        sophistication and can be easily dressed up or down.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Titanium
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Titanium is valued for its exceptional strength and
                        light weight. Bulova&rsquo;s titanium watches are
                        resistant to scratches and corrosion, making them ideal
                        for active lifestyles. The material&rsquo;s modern look
                        and hypoallergenic properties enhance both comfort and
                        durability.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Platinum
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Platinum is a rare and precious metal that offers a
                        luxurious and timeless appeal. Bulova&rsquo;s platinum
                        watches feature high-quality, heavyweight cases that are
                        resistant to tarnishing. This material is often used in
                        high-end collections, providing an elegant and enduring
                        finish.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Carbon Fiber
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Carbon fiber is known for its strength and lightweight
                        characteristics. Bulova&rsquo;s carbon fiber watches
                        feature a distinctive, textured appearance that adds a
                        modern edge to their designs. This material is often
                        used in sporty and high-performance timepieces.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Sapphire Crystal
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Sapphire crystal is renowned for its scratch resistance
                        and clarity. Bulova uses sapphire crystal for watch
                        faces to ensure durability and readability. This
                        high-quality material offers excellent protection for
                        the dial while maintaining a clear view of the time.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          Diamond
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Diamonds are used in various Bulova watches to add a
                        touch of luxury and glamour. Whether set in bezels,
                        dials, or as accents, diamonds enhance the aesthetic
                        appeal of the timepieces, creating a sparkling and
                        refined look.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>
                          PVD Coating
                          <br />
                          &nbsp;
                        </span>
                      </strong>
                      <span>
                        Physical Vapor Deposition (PVD) coating is used to apply
                        a thin layer of metal onto the watch&rsquo;s surface,
                        enhancing its appearance and durability. Bulova&rsquo;s
                        PVD-coated watches often feature finishes in colors such
                        as black, gold, and rose gold, providing a sleek and
                        modern look.
                      </span>
                    </li>
                  </ol>
                  <p>
                    <span>
                      At Alicia&apos;s Jewelers, we offer a wide range of Bulova
                      watches crafted from these premium materials, ensuring
                      that you can find a timepiece that suits your style and
                      preferences.
                    </span>
                  </p>
                  <h3>
                    <strong>
                      <span>How Much Do Bulova Watches Cost?</span>
                    </strong>
                  </h3>
                  <p>
                    <span>
                      Bulova watches are celebrated for their rich history,
                      innovative designs, and exceptional value. The brand
                      offers a diverse range of timepieces, catering to various
                      styles and budgets. Bulova watches typically range from
                      $200 to $5,000, making them accessible to both entry-level
                      buyers and seasoned watch enthusiasts.
                    </span>
                  </p>
                  <p>
                    <span>
                      Here are a few examples from Bulova&apos;s most popular
                      collections to give you an idea of what to expect when
                      purchasing a contemporary Bulova watch:
                    </span>
                  </p>
                  <h3>
                    <strong>
                      <span>Bulova Watch Models and Their Prices</span>
                    </strong>
                  </h3>
                  <div className="table-responsive">
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>Model</span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <strong>
                                <span>Starting Price</span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <strong>
                                <span>Unique Features</span>
                              </strong>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Bulova Precisionist Chronograph (ref. 98B228)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$850</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                High-precision quartz movement, chronograph
                                function, 300m water resistance
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Bulova Lunar Pilot Chronograph (ref. 96B258)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$650</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Replica of the original watch worn during the
                                Apollo 15 mission, high-performance quartz
                                movement
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Bulova Classic Automatic (ref. 96C131)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$450</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Automatic movement, open-heart dial, exhibition
                                case back
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>Bulova Marine Star (ref. 98B301)</span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$450</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                200m water resistance, chronograph function,
                                rotating bezel
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Bulova Curv Chronograph (ref. 98A162)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$1,095</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                World&apos;s first curved chronograph movement,
                                ergonomic design
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Bulova Sutton Automatic (ref. 96A269)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$395</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Automatic movement, skeleton dial, stainless
                                steel case
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>Bulova Rubaiyat (ref. 98R248)</span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$1,195</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Diamond accents, mother-of-pearl dial, stainless
                                steel bracelet
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>Bulova Futuro (ref. 98C121)</span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$325</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Modern design, sleek stainless steel case,
                                quartz movement
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>Bulova Archive Series (ref. 96K101)</span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$450</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Reissue of iconic vintage models, unique retro
                                design
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Bulova Frank Lloyd Wright Collection (ref.
                                  98A103)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$450</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Inspired by the designs of Frank Lloyd Wright,
                                architectural elements
                              </span>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <p>
                    <span>
                      Bulova offers a wide variety of timepieces, each embodying
                      the brand&apos;s commitment to quality and innovation.
                      Whether you&apos;re looking for a precision chronograph, a
                      classic dress watch, or a distinctive design inspired by
                      historical events or famous architects, Bulova has a watch
                      to suit your style. Explore the elegance and heritage of
                      Bulova watches at Alicia&apos;s Jewelers, where
                      exceptional craftsmanship meets timeless design.
                    </span>
                  </p>

                  <h2>Why Shop at Alicia&rsquo;s Jewelers?</h2>
                  <ul>
                    <li>
                      <span>
                        Authenticity Guaranteed: Shop with confidence knowing
                        that all Bulova watches at Alicia&rsquo;s Jewelers are
                        authentic and come with the full manufacturer&rsquo;s
                        warranty.
                      </span>
                    </li>
                    <li>
                      <span>
                        Expert Guidance: Our knowledgeable staff is here to
                        assist you in finding the perfect Bulova watch that
                        matches your style and needs.
                      </span>
                    </li>
                    <li>
                      <span>
                        Curated Selection: Enjoy a thoughtfully curated
                        selection of Bulova timepieces, each offering
                        exceptional quality and timeless design.
                      </span>
                    </li>
                  </ul>
                  <p>
                    <span>
                      Visit Alicia&rsquo;s Jewelers today to explore our
                      extensive range of Bulova watches and find the perfect
                      piece to enhance your collection. Discover the elegance,
                      precision, and innovation of Bulova at Alicia&rsquo;s
                      Jewelers&mdash;where luxury meets excellence.
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>&nbsp;Frederique Constant Watches&nbsp;</span>
                    </strong>
                  </p>
                  <p>
                    <strong>
                      <span>
                        Explore Frederique Constant Watches at Alicia&rsquo;s
                        Jewelers
                      </span>
                    </strong>
                  </p>
                  <p>
                    <span>
                      Discover the elegance and craftsmanship of Frederique
                      Constant watches, available at Alicia&rsquo;s Jewelers.
                      Renowned for their Swiss precision and timeless designs,
                      Frederique Constant timepieces offer a perfect blend of
                      classic style and modern innovation. Explore our curated
                      selection and find a watch that reflects your discerning
                      taste and appreciation for fine horology.
                    </span>
                  </p>
                </>
              </div>
              <div className="blrbox"></div>
              <span className="readbtn" onClick={() => setShowtext(!showtext)}>
                {showtext ? "Read Less" : "Read More"}
              </span>
            </div>
          ) : frebrand ? (
            <div className="watchsContent">
              <div
                style={
                  showtext
                    ? { height: "100%" }
                    : { height: "200px", overflow: "hidden" }
                }
                className="watchsContentData"
              >
                <>
                  <h2>Frederique Constant Collections:</h2>
                  <ol start="1" type="1">
                    <li>
                      <strong>
                        <span>Classic Manufacture Frederique Collection</span>
                      </strong>
                      <span>
                        <br />
                        &nbsp;The Classic Manufacture collection embodies
                        traditional Swiss watchmaking with a modern twist.
                        Featuring elegant dials, refined cases, and intricate
                        detailing, these watches showcase Frederique
                        Constant&rsquo;s commitment to craftsmanship. Each
                        timepiece is powered by the brand&rsquo;s in-house
                        movements, offering exceptional reliability and
                        sophistication.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>Heart Beat Frederique Collection</span>
                      </strong>
                      <span>
                        <br />
                        &nbsp;The Heart Beat collection is distinguished by its
                        unique open-heart design, which reveals the
                        watch&rsquo;s intricate movement. This collection
                        highlights Frederique Constant&rsquo;s dedication to
                        mechanical excellence, with timepieces that combine
                        aesthetic beauty with technical innovation. The exposed
                        balance wheel provides a captivating view into the
                        watch&rsquo;s inner workings.
                      </span>
                    </li>
                  </ol>

                  <ol start="3" type="1">
                    <li>
                      <strong>
                        <span>Slimline Frederique Collection</span>
                      </strong>
                      <span>
                        <br />
                        &nbsp;Embrace understated elegance with the Slimline
                        collection. Known for its minimalist design and
                        ultra-thin profiles, these watches offer a sleek and
                        refined look. The Slimline collection is perfect for
                        those who appreciate classic sophistication and a
                        modern, understated aesthetic.
                      </span>
                    </li>
                  </ol>

                  <ol start="4" type="1">
                    <li>
                      <strong>
                        <span>Hybrid Manufacture Frederique Collection</span>
                      </strong>
                      <span>
                        <br />
                        &nbsp;The Hybrid Manufacture collection merges
                        traditional mechanical watchmaking with modern
                        smartwatch functionality. These innovative timepieces
                        feature an analog display combined with smart features
                        such as fitness tracking and notifications, providing a
                        seamless blend of classic style and contemporary
                        technology.
                      </span>
                    </li>
                  </ol>

                  <ol start="5" type="1">
                    <li>
                      <strong>
                        <span>Vintage Rally Frederique Collection</span>
                      </strong>
                      <span>
                        <br />
                        &nbsp;Inspired by vintage racing heritage, the Vintage
                        Rally collection features sporty designs and chronograph
                        functions. With classic automotive-inspired details and
                        durable materials, these watches are perfect for
                        enthusiasts of motorsports and vintage style.
                      </span>
                    </li>
                  </ol>

                  <ol start="6" type="1">
                    <li>
                      <strong>
                        <span>Frederique Constant X Frederique Collection</span>
                      </strong>
                      <span>
                        <br />
                        &nbsp;The Frederique Constant X collection represents
                        the brand&rsquo;s commitment to pushing the boundaries
                        of horology. Featuring bold designs and advanced
                        complications, these timepieces are designed for those
                        who seek innovation and exclusivity in their watches.
                      </span>
                    </li>
                  </ol>
                  <p>
                    <strong>
                      <span>
                        Why Choose Frederique Constant Watches at Alicia&rsquo;s
                        Jewelers?
                      </span>
                    </strong>
                  </p>
                  <ul>
                    <li>
                      <span>
                        Unmatched Craftsmanship: Frederique Constant watches are
                        celebrated for their Swiss precision and artisanal
                        craftsmanship, ensuring exceptional quality and
                        durability.
                      </span>
                    </li>
                    <li>
                      <span>
                        Diverse Collections: From classic elegance to innovative
                        hybrids, our selection encompasses a range of styles to
                        suit every taste and occasion.
                      </span>
                    </li>
                    <li>
                      <span>
                        Expert Assistance: Our knowledgeable staff at
                        Alicia&rsquo;s Jewelers is dedicated to helping you find
                        the perfect Frederique Constant timepiece, offering
                        personalized service and expert advice.
                      </span>
                    </li>
                    <li>
                      <span>
                        Authenticity Guaranteed: Shop with confidence knowing
                        that all Frederique Constant watches at Alicia&rsquo;s
                        Jewelers are genuine and come with the full
                        manufacturer&rsquo;s warranty.
                      </span>
                    </li>
                  </ul>
                  <p>
                    <span>
                      Visit Alicia&rsquo;s Jewelers to explore the exquisite
                      Frederique Constant collection and discover the perfect
                      watch that combines timeless elegance with modern
                      innovation. Experience the artistry and precision of
                      Frederique Constant at Alicia&rsquo;s Jewelers&mdash;where
                      luxury and excellence meet.
                    </span>
                  </p>
                  <p>
                    <span>
                      Here&rsquo;s a description of some of the best-selling
                      Frederique Constant watches:
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>
                        Best-Selling Frederique Constant Watches at
                        Alicia&rsquo;s Jewelers
                      </span>
                    </strong>
                  </p>
                  <p>
                    <span>
                      Frederique Constant is renowned for crafting exquisite
                      timepieces that combine Swiss precision with timeless
                      design. At Alicia&rsquo;s Jewelers, we proudly offer some
                      of the best-selling models from this esteemed brand.
                      Explore our selection to discover watches that have
                      captured the hearts of collectors and enthusiasts alike.
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>1. Frederique Constant Slimline Moonphase</span>
                    </strong>
                  </p>
                  <p>
                    <span>
                      The Slimline Moonphase watch is celebrated for its elegant
                      simplicity and sophisticated moonphase complication. Its
                      ultra-thin profile and refined design make it a perfect
                      choice for formal occasions. The watch features a classic
                      moonphase indicator and date function, adding a touch of
                      luxury to its minimalist aesthetic.
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>2. Frederique Constant Heart Beat</span>
                    </strong>
                  </p>
                  <p>
                    <span>
                      The Heart Beat collection is distinguished by its unique
                      open-heart design, which showcases the movement&rsquo;s
                      intricate workings through a transparent section on the
                      dial. This model highlights the brand&rsquo;s commitment
                      to mechanical excellence with a visible balance wheel and
                      traditional craftsmanship.
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>3. Frederique Constant Classic Manufacture</span>
                    </strong>
                  </p>
                  <p>
                    <span>
                      &nbsp;Known for its elegant design and in-house movements,
                      the Classic Manufacture watch offers a refined look with a
                      classic dial and traditional complications such as a date
                      display and small seconds. Its timeless design and
                      exceptional quality make it a popular choice among
                      enthusiasts.
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>4. Frederique Constant Hybrid Manufacture</span>
                    </strong>
                  </p>
                  <p>
                    <span>
                      Combining traditional mechanical watchmaking with modern
                      smartwatch technology, the Hybrid Manufacture offers both
                      classic analog features and smart functions like activity
                      tracking and notifications. This model is perfect for
                      those who appreciate a blend of traditional style and
                      contemporary technology.
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>5. Frederique Constant Vintage Rally</span>
                    </strong>
                  </p>
                  <p>
                    <span>
                      &nbsp;Inspired by vintage racing, the Vintage Rally watch
                      features chronograph functionality and automotive-inspired
                      design elements. With its sporty look and reliable
                      performance, this model is ideal for motorsport
                      enthusiasts and those who appreciate a classic, dynamic
                      style.
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>6. Frederique Constant Worldtimer</span>
                    </strong>
                  </p>
                  <p>
                    <span>
                      The Worldtimer watch is designed for global travelers,
                      offering the ability to display time in multiple time
                      zones simultaneously. Its sophisticated design and
                      practical functionality make it a best-seller for those
                      who need both style and utility.
                    </span>
                  </p>
                  <p>
                    <span>&nbsp;</span>
                  </p>
                  <p>
                    <strong>
                      <span>7. Frederique Constant Highlife Automatic</span>
                    </strong>
                  </p>
                  <p>
                    <span>
                      The Highlife Automatic watch features a distinctive design
                      with a versatile bracelet and a rotating bezel. Its
                      automatic movement and robust construction make it a
                      popular choice for those seeking a blend of elegance and
                      durability.
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>
                        Why Shop Frederique Constant at Alicia&rsquo;s Jewelers?
                      </span>
                    </strong>
                  </p>
                  <ul>
                    <li>
                      <strong>
                        <span>Exceptional Quality:</span>
                      </strong>
                      <span>
                        &nbsp;Frederique Constant watches are known for their
                        Swiss precision and craftsmanship, ensuring that each
                        timepiece is a masterpiece of horological excellence.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>Curated Selection:</span>
                      </strong>
                      <span>
                        &nbsp;Our best-selling Frederique Constant watches offer
                        a range of styles and functionalities, catering to
                        various preferences and needs.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>Expert Guidance:</span>
                      </strong>
                      <span>
                        &nbsp;Our knowledgeable staff at Alicia&rsquo;s Jewelers
                        is here to help you find the perfect Frederique Constant
                        watch, offering personalized service and expert advice.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>Authenticity Guaranteed:</span>
                      </strong>
                      <span>
                        &nbsp;Shop with confidence knowing that all Frederique
                        Constant watches at Alicia&rsquo;s Jewelers are genuine
                        and come with the full manufacturer&rsquo;s warranty.
                      </span>
                    </li>
                  </ul>
                  <p>
                    <span>
                      Visit Alicia&rsquo;s Jewelers to explore our collection of
                      best-selling Frederique Constant watches and discover the
                      perfect timepiece that combines luxury, style, and
                      innovation.
                    </span>
                  </p>
                  <p>
                    <strong>
                      <span>Why Choose Frederique Constant?</span>
                    </strong>
                  </p>
                  <ul>
                    <li>
                      <strong>
                        <span>Swiss Craftsmanship:</span>
                      </strong>
                      <span>
                        &nbsp;Each Frederique Constant watch is crafted in
                        Switzerland with meticulous attention to detail and an
                        unwavering commitment to quality. The brand&rsquo;s
                        heritage of excellence ensures that every timepiece is a
                        masterpiece of traditional watchmaking.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>Innovative Designs:</span>
                      </strong>
                      <span>
                        &nbsp;From classic elegance to cutting-edge technology,
                        Frederique Constant offers a range of designs that cater
                        to diverse tastes. Whether you seek the refined beauty
                        of the Classic Manufacture, the smart functionality of
                        the Hybrid Manufacture, or the timeless charm of the
                        Slimline collection, you&rsquo;ll find a watch that
                        suits your preferences.
                      </span>
                    </li>
                    <li>
                      <strong>
                        <span>Exclusive Collections:</span>
                      </strong>
                      <span>
                        &nbsp;Explore collections such as the Heart Beat, which
                        features an open-heart design showcasing the intricate
                        movement, or the Vintage Rally, inspired by classic
                        motorsport. Each collection offers unique features and
                        styles, ensuring that you find a timepiece that
                        resonates with your personal style.
                        <br />
                        &nbsp;
                        <br />
                        &nbsp;
                      </span>
                      <strong>
                        <span>
                          How Much Do Frederique Constant Watches Cost?
                        </span>
                      </strong>
                    </li>
                    <li>
                      <span>
                        Frederique Constant watches are renowned for their blend
                        of classical design, technical innovation, and
                        affordability. The brand offers a wide range of
                        timepieces, catering to both new collectors and seasoned
                        aficionados. Frederique Constant watches typically range
                        from the low hundreds to around $30,000, making them
                        accessible to a broad audience while still delivering
                        exceptional quality and craftsmanship.
                      </span>
                    </li>
                    <li>
                      <span>
                        Here are a few examples from Frederique Constant&apos;s
                        most popular collections to give you an idea of what to
                        expect when purchasing a contemporary Frederique
                        Constant watch:
                      </span>
                    </li>
                  </ul>
                  <p>
                    <span>&nbsp;</span>
                  </p>
                  <div>
                    <ul>
                      <li>
                        <strong>
                          <span>
                            Frederique Constant Watch Models and Their Prices
                          </span>
                        </strong>
                      </li>
                    </ul>
                  </div>
                  <div className="table-responsive">
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>Model</span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <strong>
                                <span>Starting Price</span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <strong>
                                <span>Unique Features</span>
                              </strong>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Frederique Constant Slimline Moonphase
                                  Manufacture (ref. FC-705S4S6)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$3,695</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Moonphase complication, in-house movement,
                                elegant slim case
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Frederique Constant Classic Index Automatic
                                  (ref. FC-303V5B4)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$1,195</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Automatic movement, Roman numeral markers, date
                                function
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Frederique Constant Highlife Automatic
                                  Skeleton (ref. FC-310NSKT4NH6B)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$4,295</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Openwork dial, automatic movement, integrated
                                bracelet
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Frederique Constant Ladies Automatic (ref.
                                  FC-303LGD3B4)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$2,195</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Mother-of-pearl dial, diamond markers, rose
                                gold-plated case
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Frederique Constant Classics Art Deco (ref.
                                  FC-200MPW2V6B)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$1,095</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Guilloch&eacute; dial, Art Deco design,
                                stainless steel bracelet
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Frederique Constant Flyback Chronograph
                                  Manufacture (ref. FC-760V4H4)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$3,995</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Flyback chronograph, in-house movement, 42-hour
                                power reserve
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Frederique Constant Runabout Automatic (ref.
                                  FC-303RMN5B6)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$1,595</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Nautical design, automatic movement, date
                                function
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Frederique Constant Horological Smartwatch
                                  (ref. FC-285S5B6)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$1,295</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Smartwatch functionality, activity tracking,
                                classic analog design
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Frederique Constant Manufacture Perpetual
                                  Calendar (ref. FC-775V4S4)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$8,795</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Perpetual calendar, in-house movement, moonphase
                                complication
                              </span>
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <p>
                              <strong>
                                <span>
                                  Frederique Constant Vintage Rally Healey
                                  Automatic (ref. FC-303HVBR5B4)
                                </span>
                              </strong>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>$2,195</span>
                            </p>
                          </td>
                          <td>
                            <p>
                              <span>
                                Racing-inspired design, automatic movement,
                                limited edition
                              </span>
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div>
                    <ul>
                      <li>
                        <span>
                          Frederique Constant offers a wide range of luxurious
                          and sophisticated timepieces that cater to various
                          tastes and preferences. Whether you are looking for a
                          classic dress watch, a sporty chronograph, or an
                          innovative smartwatch, Frederique Constant has
                          something to offer. Explore the elegance and precision
                          of Frederique Constant watches at Alicia&apos;s
                          Jewelers, where luxury meets accessibility.
                        </span>
                      </li>
                    </ul>
                  </div>
                  <p>
                    <span>&nbsp;</span>
                  </p>
                  <p>
                    <strong>
                      <span>Discover Your Frederique Constant Watch Today</span>
                    </strong>
                  </p>
                  <p>
                    <span>
                      Visit Alicia&rsquo;s Jewelers to explore our exquisite
                      selection of Frederique Constant timepieces. Whether
                      you&rsquo;re drawn to the brand&rsquo;s elegant designs,
                      innovative features, or exclusive collections, our team is
                      here to help you find the perfect watch. Experience the
                      artistry and precision of Frederique Constant at
                      Alicia&rsquo;s Jewelers, where luxury meets excellence.
                    </span>
                  </p>
                </>
              </div>
              <div className="blrbox"></div>
              <span className="readbtn" onClick={() => setShowtext(!showtext)}>
                {showtext ? "Read Less" : "Read More"}
              </span>
            </div>
          ) : (
            ""
          )}
        </Container>
      </div>
    </>
  );
};

export default Watches;
